// removed by extract-text-webpack-plugin
module.exports = {"toggleMode":"toggleMode","project_container":"project_container","project_container_public":"project_container_public","project_main_section":"project_main_section","project_main_section_public":"project_main_section_public","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/style.scss
// module id = 1372
// module chunks = 0